import React from 'react';
import { orderBy } from 'lodash';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { TransitionGroup } from 'react-transition-group';
// import { v4 as uuidv4 } from 'uuid';
// import { useSnackbar } from 'notistack';
import { Button, Fade, SwipeableDrawer, Typography } from '@mui/material';
import FuseScrollbars from '@fuse/core/FuseScrollbars';

import { useSettings } from 'app/main/components';
import withReducer from 'app/store/withReducer';
import {
	dismissNotification,
	dismissAllNotifications,
	readNotification
	// sendNotification
} from 'app/store/notifications/notificationsHubSlice';
import { selectNotifications } from 'app/store/notifications/notificationsSlice';

import reducer from './store';
import { closeNotificationPanel, toggleNotificationPanel } from './store/stateSlice';
import NotificationCard from './NotificationCard';

function NotificationPanel() {
	const location = useLocation();
	const dispatch = useDispatch<any>();
	const { t } = useSettings();

	const state = useSelector(({ notificationPanel }: any) => notificationPanel.state);
	const notifications = useSelector(selectNotifications);
	const orderedNotifications = orderBy(notifications, 'createdAt', 'desc');

	React.useEffect(() => {
		if (state) {
			dispatch(closeNotificationPanel());
		}
		// eslint-disable-next-line
	}, [location, dispatch]);

	function handleClose() {
		dispatch(closeNotificationPanel());
	}

	function handleRead(id) {
		dispatch(readNotification({ notificationUid: id }));
	}

	function handleDismiss(id) {
		dispatch(dismissNotification({ notificationUid: id }));
	}

	function handleDismissAll() {
		dispatch(dismissAllNotifications());
	}

	return (
		<SwipeableDrawer
			open={state}
			anchor="right"
			onOpen={_ev => {}}
			onClose={_ev => dispatch(toggleNotificationPanel())}
			disableSwipeToOpen
			sx={theme => ({
				'.MuiDrawer-paper': {
					backgroundColor: theme.palette.background.default,
					width: '100%',
					maxWidth: 400
				}
			})}
		>
			<FuseScrollbars className="p-16">
				<div className="flex flex-col">
					<div className="mb-4 flex items-center justify-between pt-4">
						<Typography className="text-28 font-semibold leading-none">
							{t('NOTIFICATIONS_TITLE')}
						</Typography>
						<Button onClick={handleClose}>{t('DIALOG_ACTION_CLOSE')}</Button>
						{/* <Button
							onClick={() =>
								dispatch(
									sendNotification({
										message: {
											id: uuidv4(),
											createdBy: 'D0854A23-8906-46D4-8806-BC0980D7880B',
											assignedTo: 'D0854A23-8906-46D4-8806-BC0980D7880B',
											title: 'Nuova Azienda assegnata',
											body: 'Pippo Baudo ti ha assegnato l\'Azienda "ACME srl"',
											url: 'https://www.youtube.com/watch?v=hHIR7iOFn08',
											icon: 'domain',
											variant: 'info'
										}
									})
								)
							}
						>
							test
						</Button> */}
					</div>
					<Typography
						className="mb-16 cursor-pointer text-12 underline"
						color="secondary"
						onClick={handleDismissAll}
					>
						{t('NOTIFICATIONS_DISMISS_ALL')}
					</Typography>
					<TransitionGroup>
						{orderedNotifications.map(notification => (
							<Fade key={notification.id} in timeout={{ enter: 200, exit: 400 }} unmountOnExit>
								<div>
									<NotificationCard
										className="mb-8"
										notification={notification}
										onLinkClick={handleRead}
										onDismiss={handleDismiss}
									/>
								</div>
							</Fade>
						))}
					</TransitionGroup>
					{/* {notifications.length === 0 && (
						<Typography className="text-center text-24" color="textSecondary">
							{t('NOTIFICATIONS_NONE')}
						</Typography>
					)} */}
				</div>
			</FuseScrollbars>
		</SwipeableDrawer>
	);
}

export default withReducer('notificationPanel', reducer)(React.memo(NotificationPanel));
